import React from 'react'
import { FaFacebook } from 'react-icons/fa'
import { useDispatch } from 'react-redux'
import { Button } from '@material-ui/core'
import { signUpWithFacebook, signInWithFacebook } from 'actions/auth'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  main: {
    backgroundColor: '#4267B2',
    color: 'white',
    height: '43px',
    textTransform: 'none',
    '&:hover': { backgroundColor: '#4267B2' }
  }
}))

const FacebookAuthenticate = ({ type = 'signIn', communityId, onSuccessCallback }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const handleLogin = () => {
    window.FB.login(function({ status, authResponse }) {
      if (status === 'connected') {
        const { accessToken } = authResponse
        dispatch(type === 'signUp' ? signUpWithFacebook(accessToken, communityId) : signInWithFacebook(accessToken)).then(() => {
          onSuccessCallback()
        })
      }
    }, { scope: 'email' })
  }

  return (
    <Button
      className={classes.main}
      fullWidth
      startIcon={<FaFacebook size='1.5em' />}
      onClick={handleLogin}
    >
      {`${type === 'signUp' ? 'Sign Up' : 'Sign In'} with Facebook`}
    </Button>
  )
}

export default FacebookAuthenticate
